import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
  MobileNavigationHorizontal,
  MobileNavigationVertical,
  NavigationVerticalList,
} from '@cotyorg/ccx-organism-navigation';
import containsOrIsNode from '@cotyorg/ccx-utils/js/helpers/containsOrIsNode';
import HeaderNavButton from './HeaderNavButton';
import { toggleNavigation as toggleNavigationAction } from './modules';

const navTypeHorizontal = 'horizontal';
const navTypeVertical = 'vertical';

class HeaderNavToggle extends PureComponent {
  componentDidMount() {
    this.documentClickHandler = (e) => {
      const { toggleNavigation, isNavigationVisible, currentBreakpoint } = this.props;

      const isLargeBreakpoint = currentBreakpoint && currentBreakpoint.includes('large');

      const shouldHideNavigation = (
        !containsOrIsNode(this.verticalListWrapper, e.target) &&
        !containsOrIsNode(this.navButtonWrapper, e.target) &&
        isLargeBreakpoint &&
        isNavigationVisible
      );

      if (shouldHideNavigation) {
        toggleNavigation();
      }
    };

    document.addEventListener('click', this.documentClickHandler, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.documentClickHandler, false);
  }

  render() {
    const {
      navCssClass,
      isNavigationVisible,
      toggleNavigation,
      isMinimalHeader,
      navImageSrc,
      navImageSrcSet,
      navType,
      currentBreakpoint,
      leftChevronIconSrc,
      rightChevronIconSrc,
      closeIconSrc,
      hamburgerIconSrc,
      mobileNavButtonOpenText,
      mobileNavButtonCloseText,
      disableSwipe,
      hamburgerIconWidth,
      hamburgerIconHeight,
    } = this.props;

    const isLargeBreakpoint = currentBreakpoint && currentBreakpoint.includes('large');

    const buttonClassName = classNames('button--clear', {
      'header__navigation-button--show-always': isMinimalHeader,
    });

    return (
      <div className={navCssClass}>
        <div ref={(el) => { this.navButtonWrapper = el; }}>
          <HeaderNavButton
            onClick={toggleNavigation}
            extraClass={buttonClassName}
            isSelected={!!isNavigationVisible}
            closeIconSrc={closeIconSrc}
            hamburgerIconSrc={hamburgerIconSrc}
            hamburgerIconWidth={hamburgerIconWidth}
            hamburgerIconHeight={hamburgerIconHeight}
            mobileNavButtonOpenText={mobileNavButtonOpenText}
            mobileNavButtonCloseText={mobileNavButtonCloseText}
          />
        </div>

        {isMinimalHeader && isLargeBreakpoint && (
          <div ref={(el) => { this.verticalListWrapper = el; }}>
            <NavigationVerticalList
              isVisible={!!isNavigationVisible}
              imageSrc={navImageSrc}
              imageSrcSet={navImageSrcSet}
            />
          </div>
        )}

        {navType === navTypeHorizontal && !isLargeBreakpoint && (
          <MobileNavigationHorizontal
            isVisible={!!isNavigationVisible}
            leftChevronIconSrc={leftChevronIconSrc}
            rightChevronIconSrc={rightChevronIconSrc}
            disableSwipe={disableSwipe}
          />
        )}

        {navType === navTypeVertical && !isLargeBreakpoint && (
          <MobileNavigationVertical isVisible={!!isNavigationVisible} />
        )}

      </div>
    );
  }
}

HeaderNavToggle.propTypes = {
  navType: PropTypes.oneOf([navTypeHorizontal, navTypeVertical]),
  navCssClass: PropTypes.string,
  isNavigationVisible: PropTypes.bool,
  toggleNavigation: PropTypes.func,
  isMinimalHeader: PropTypes.bool,
  navImageSrc: PropTypes.string,
  navImageSrcSet: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  currentBreakpoint: PropTypes.string.isRequired,
  leftChevronIconSrc: PropTypes.string,
  rightChevronIconSrc: PropTypes.string,
  closeIconSrc: PropTypes.string,
  hamburgerIconSrc: PropTypes.string,
  mobileNavButtonOpenText: PropTypes.string,
  mobileNavButtonCloseText: PropTypes.string,
  hamburgerIconWidth: PropTypes.number,
  hamburgerIconHeight: PropTypes.number,
};

HeaderNavToggle.defaultProps = {
  navType: navTypeHorizontal,
};

const mapStateToProps = ({ header, breakpoints = {} }) => ({
  isNavigationVisible: header.isNavigationVisible,
  currentBreakpoint: breakpoints.current,
});

const mapDispatchToProps = dispatch => ({
  toggleNavigation: () => dispatch(toggleNavigationAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNavToggle);
